document.addEventListener('DOMContentLoaded', () => {
    /**
     * Liquid Ajax Cart (defaults): quantity +/- waits 300ms after the last click before
     * POST /cart/change.js, then replaces the whole cart-drawer section from Shopify.
     * Lower debounce = snappier qty changes; the request queue still runs one update at a time.
     */
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.conf === 'function') {
        window.liquidAjaxCart.conf('quantityTagDebounce', 20);
    }

    const FREE_SHIPPING_THRESHOLD = 100; // dollars

    const drawers = [
        {
            name        : 'cart',
            element     : document.getElementById('shopify-section-cart-drawer'),
            openButtons : [document.querySelector('.open-cart')],
            closeButtons: [document.querySelector('.close-cart')],
        }, {
            name        : 'mobileMenu',
            element     : document.querySelector('.menu-drawer'),
            openButtons : [document.querySelector('.header-hamburger')],
            closeButtons: [document.getElementById('close-menu-drawer')],
        },
    ];

    const overlay = document.querySelector('.drawer-overlay');

    // Wire open/close buttons
    drawers.forEach(({ element, openButtons = [], closeButtons = [] }) => {
        openButtons.filter(Boolean).forEach(btn => btn.addEventListener('click', () => openDrawer(element)));
        closeButtons.filter(Boolean).forEach(btn => btn.addEventListener('click', () => closeDrawer(element)));
    });

    // Core drawer controls
    function openDrawer(drawer) {
        if (!drawer) return;
        closeAllDrawers(); // only one open at a time
        drawer.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
        overlay?.classList.add('active');
        document.body.classList.add('menu-open');
    }

    function closeDrawer(drawer) {
        if (!drawer) return;
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
        overlay?.classList.remove('active');
    }

    function closeAllDrawers() {
        drawers.forEach(({ element }) => closeDrawer(element));
        overlay?.classList.remove('active');
    }

    function openCartDrawer() {
        const cartDrawer = drawers.find(d => d.name === 'cart')?.element;
        if (cartDrawer) openDrawer(cartDrawer);
    }

    document.addEventListener('click', (event) => {
        const closeBtn = event.target.closest('.close-cart');
        if (!closeBtn) return;
        event.preventDefault();
        const cartDrawer = drawers.find(d => d.name === 'cart')?.element;
        if (cartDrawer) {
            closeDrawer(cartDrawer);
        }
    });

    // Overlay + ESC
    overlay?.addEventListener('click', closeAllDrawers);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAllDrawers();
    });

    // ===== FREE SHIPPING + CART COUNT =====
    function updateCartDrawerItemCount(cart) {
        const countEl = document.querySelector('[data-cart-drawer-item-count]');
        const suffixEl = document.querySelector('[data-cart-drawer-count-suffix]');
        const badgeEl = document.querySelector('.cart-drawer-heading__count-badge');
        if (countEl && cart && typeof cart.item_count === 'number') {
            const n = cart.item_count;
            countEl.textContent = String(n);
            if (suffixEl) {
                suffixEl.textContent = n === 1 ? 'item' : 'items';
            }
            if (badgeEl) {
                badgeEl.setAttribute('aria-label', `${n} ${n === 1 ? 'item' : 'items'} in cart`);
            }
        }
    }

    function updateFreeShippingBar(cart) {
        const banner = document.querySelector('.free-shipping-banner');
        const below = document.querySelector('.free-shipping-banner__below');
        const unlocked = document.querySelector('.free-shipping-banner__unlocked');
        const textBelow = document.querySelector('.free-shipping-text--below');
        const barBelow = document.querySelector('.free-shipping-banner__below .free-shipping-progress-fill');
        if (!cart) return;

        updateCartDrawerItemCount(cart);

        const subtotalCents = cart.items_subtotal_price ?? cart.total_price ?? 0;
        const subtotal = subtotalCents / 100;
        const remaining = FREE_SHIPPING_THRESHOLD - subtotal;
        const qualifies = remaining <= 0;
        const percent = Math.min((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

        if (textBelow) {
            if (remaining > 0) {
                textBelow.textContent = `Add $${remaining.toFixed(2)} more to get Free Shipping`;
            }
        }
        if (barBelow) {
            barBelow.style.width = `${percent}%`;
        }

        if (banner) {
            banner.classList.toggle('free-shipping-banner--unlocked', qualifies);
        }
        if (below) {
            if (qualifies) {
                below.setAttribute('hidden', '');
            } else {
                below.removeAttribute('hidden');
            }
        }
        if (unlocked) {
            if (qualifies) {
                unlocked.removeAttribute('hidden');
                unlocked.setAttribute('aria-hidden', 'false');
            } else {
                unlocked.setAttribute('hidden', '');
                unlocked.setAttribute('aria-hidden', 'true');
            }
        }
    }

    // ===== LIQUID AJAX CART INIT =====
    function onAjaxCartInit() {
        updateFreeShippingBar(window.liquidAjaxCart?.cart);
    }
    if (window.liquidAjaxCart?.init) {
        onAjaxCartInit();
    } else {
        document.addEventListener('liquid-ajax-cart:init', onAjaxCartInit);
    }

    // ===== LISTEN FOR CART REQUESTS (Optimistic open) =====
    document.addEventListener('liquid-ajax-cart:request-start', (event) => {
        const { requestState } = event.detail || {};
        // Open ASAP when adding to cart (no network wait)
        if (requestState?.requestType === 'add') {
            openCartDrawer();
        }
    });

    // ===== LISTEN FOR CART UPDATES (progress + errors) =====
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
        const { requestState, cart } = event.detail || {};

        if (requestState?.responseData?.ok && cart) {
            updateFreeShippingBar(cart);
        } else if (requestState?.requestType === 'add' && !requestState?.responseData?.ok) {
            // Optional: handle add-to-cart failure (drawer is already open optimistically)
            // e.g., show a toast message inside the drawer
            const errTarget = document.querySelector('.cart-drawer-error');
            if (errTarget) {
                errTarget.textContent = requestState?.responseData?.message || 'Could not add to cart.';
            }
        }
    });
});